import CTNCalendar from '@ctn/ui/components/ctn-calendar';
import CTNInput from '@ctn/ui/components/ctn-input';
import CTNModal from '@ctn/ui/components/ctn-modal';
import { useFormContext } from 'react-hook-form';

import EventoListado from '@/components/EventoListado';

import { ESTADO_COLOR } from '@/constants/tramite.constants';
import { commonCalendar } from '@/helpers/calendar';
import { type FormTramiteValues } from '@/interfaces/model/don.interface';

import FieldDisplay from '../FieldDisplay';

export type ModalHistorialSolicitudProps = {
	readonly onClose: () => void;
	readonly isOpen: boolean;
};

export type Form = Partial<
Pick<FormTramiteValues, 'estadoTramite' | 'fechaCreacion' | 'historial' | 'numeroTramite' | 'tipoNNJJ'>
>;

const ModalHistorialSolicitud = ({ onClose, isOpen }: ModalHistorialSolicitudProps) => {
	const { control, watch } = useFormContext<Form>();

	const estadoTramite = watch('estadoTramite');

	return (
		<CTNModal
			closeable
			show={isOpen}
			type="basic"
			size="xxl"
			alignButtons="right"
			title="Historial de la solicitud"
			actionButtons={[
				{
					key: 'cerrar',
					mode: 'tertiary',
					label: 'Cerrar',
					minWidth: '140',
					size: 'size-40',
					onClick: onClose,
				},
			]}
			content={
				<>
					<div className="[ o-grid ] [ c-pnp-form-group c-pnp-form-group--accent c-pnp-form-group--radius c-pnp-form-group--display-only ] [ u-flow ]">
						<div className="o-grid__row">
							<CTNCalendar
								{...commonCalendar}
								noFeedBack
								displayOnly
								condensed
								locale="es"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="fechaCreacion"
								label="Fecha alta"
								control={control}
							/>
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="numeroTramite"
								label="Nº de solicitud"
								control={control}
							/>
							<FieldDisplay
								noFeedBack
								condensed
								displayOnly
								className="o-grid__col-12 o-grid__col-3@portrait"
								name="estadoTramite.descripcion"
								label="Estado"
								iconLeft={{
									icon: 'status',
									color: ESTADO_COLOR[estadoTramite?.id as keyof typeof ESTADO_COLOR] ?? 'gray-50',
								}}
								control={control}
							/>
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="tipoNNJJ.descripcion"
								label="Tipo de negocio jurídico"
								control={control}
							/>
						</div>
					</div>
					<EventoListado
						className="u-mt-24"
						data={watch('historial') ?? []}
						disabledColumn={{ detalle: true }}
					/>
				</>
			}
			onClose={onClose}
		/>
	);
};

export default ModalHistorialSolicitud;
